import axios from 'axios'
import cookies from 'vue-cookies'

export default {
  namespaced: true,
  state: {
    translationsLastUpdate: null,
    notifications: localStorage && localStorage.translations ? JSON.parse(localStorage.translations).pages.common.notifications : {}
  },
  mutations: {
    setTranslationsLastUpdate(state, payload) {
      state.translationsLastUpdate = payload
    },
  },
  getters: {
    translationsLastUpdate: (state) => state.translationsLastUpdate,
  },
  actions: {
    onTranslationsAllPage({ commit, rootState }, { language_id, storage, type }) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/common/interface/' + language_id + '?type=' + type,
          method: 'GET',
        })
          .then((resp) => {
            // console.log(resp)
            resp.data.language_id = language_id
            // cookies.set(
            //     page_name,
            //     resp.data,
            //     '30d',
            //     null,
            //     null,
            //     true,
            //     'Strict'
            // )
            // localStorage.setItem(page_name, JSON.stringify(resp.data))
            storage[type === 'web' ? 'translations' : type] = resp.data
            resolve(resp.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onTranslationsLastUpdate({ commit, rootState }, { language_id, type }) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/common/interface/last-update/' +
            language_id +
            '?type=' +
            type,
          method: 'GET',
        })
          .then((resp) => {
            resolve(resp.data.last_update)
            // commit('setTranslationsLastUpdate', resp.data.last_update)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
